import React, { FC } from "react";

import { useHeaderMenu } from "../../../../hooks/use-header-menu";
import { SearchForm } from "../../common/search-form";
import { HeaderMenuItemDetailTitle } from "../header-menu-item-detail-title";

export interface SearchSpecialItemProps {}

export const SearchSpecialItem: FC<SearchSpecialItemProps> = ({}) => {
  const { labels } = useHeaderMenu();
  return (
    <div className="flex flex-col gap-4 w-full">
      <HeaderMenuItemDetailTitle
        title={labels["header-menu-search-title"]}
        titleClassName="text-primary"
      />
      <SearchForm />
    </div>
  );
};
